// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Scrollbar global — tema oscuro (#111 / #4b5563).
 * Se aplica a TODOS los elementos con overflow para evitar
 * la barra de scroll nativa de Chrome / navegador.
 */

*,
*::before,
*::after {
  scrollbar-width: thin;
  scrollbar-color: #4b5563 #111111;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #111111;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #4b5563;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #6b7280;
}
`, "",{"version":3,"sources":["webpack://./src/styles/dark-scroll-areas.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;;;EAGE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/**\n * Scrollbar global — tema oscuro (#111 / #4b5563).\n * Se aplica a TODOS los elementos con overflow para evitar\n * la barra de scroll nativa de Chrome / navegador.\n */\n\n*,\n*::before,\n*::after {\n  scrollbar-width: thin;\n  scrollbar-color: #4b5563 #111111;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #111111;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #4b5563;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #6b7280;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
